<template>
  <div id="grid-cronograma">
    <div v-if="loading">
      <loading></loading>
    </div>
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex>
          <br />
          <v-btn
            v-if="
              usuarioLoggedTipe == 'PROVEEDOR' ||
              usuarioLoggedTipe == 'ADMINISTRADOR'
            "
            color="primary"
            dark
            class="mb-2"
            @click="openCronograma()"
            >Agendar cronograma</v-btn
          >
        </v-flex>
        <carga-masiva
          :apiValidateDocument="apiValidateDocument"
          :apiSaveDocument="apiSaveDocument"
          :apiDownloadDocument="apiDownloadDocument"
          :templateTitle="templateTitle"
        ></carga-masiva>
      </v-layout>
      <v-spacer></v-spacer>
      <v-layout justify-center>
        <v-flex xs12 md4>
          <v-select
            v-model="regionValue"
            item-text="nombre"
            item-value="code"
            :items="regionesSelect"
            label="Region"
            data-vv-name="listaRegiones"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="centroAcopioValue"
            item-text="nombre"
            item-value="code"
            :items="centroAcopioSelect"
            label="Centro Acopio"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="centroOperacionValue"
            item-text="nombre"
            item-value="code"
            :items="centroOperacionSelect"
            label="Centro Operacion"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="fechaValue"
            :items="fechaSelect"
            label="Fecha"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4> </v-flex>
        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="filterCronograma()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <!-- BOTON NO INCLUIDO EN DISEÑO DEBERIA ESTAR -->
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="itemsCronograma"
            :pagination.sync="miPaginacion"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.nivel.descripcion }}</td>
              <td class="text-xs-left">{{ props.item.region.nombre }}</td>
              <td class="text-xs-left">
                {{ props.item.centroOrigen.codCentro }}
              </td>
              <td class="text-xs-left">
                {{ props.item.centroDestino.codCentro }}
              </td>
              <td class="text-xs-left">
                {{ props.item.material.descripcion }}
              </td>
              <td
                v-if="
                  props.item.obserFecha !== undefined &&
                  props.item.obserFecha != null &&
                  props.item.obserFecha != ''
                "
                class="text-xs-left"
              >
                <v-chip :color="getColor()" dark>{{
                  props.item.fecha_movimiento + " " + props.item.hora_movimiento
                }}</v-chip>
              </td>
              <td v-else class="text-xs-left">
                {{
                  props.item.fecha_movimiento + " " + props.item.hora_movimiento
                }}
              </td>
              <td>
                <div class="text-xs-center">
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Consultar detalle"
                    @click="viewCronograma(props.item.id)"
                    ><v-icon>remove_red_eye</v-icon>
                  </v-btn>
                </div>
              </td>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA PROVEEDORES -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <td>
                <template>
                  <v-chip color="orange" dark>Registro con comentario</v-chip>
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                  >
                    <v-icon>remove_red_eye</v-icon> </v-btn
                  >&nbsp;Consultar detalle
                </template>
              </td>
            </div>
          </v-card-actions>
          <!--fin iconos leyenda-->
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="miPaginacion.totalItems"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
          <v-dialog v-model="dialogLoading" persistent max-width="390">
            <loading-descarga></loading-descarga>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          color="primary"
          dark
          class="mb-2"
          @click="downloadComplete()"
          >Descarga Completa <v-icon right dark>folder</v-icon></v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";
import CargaMasiva from "@/components/CargaMasiva.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "grid-cronograma",
  components: {
    Loading,
    CargaMasiva,
    LoadingDescarga,
  },
  mixins: [misMixins],
  props: {
    rowsTable: "",
    tipeView: "",
  },

  data() {
    return {
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      dialogLoading: false,
      botonValida: 1,
      loading: false,
      itemsCronograma: [],
      dialogValidation: false,
      dialog: false,
      resp: "",
      contratoId: "",
      itemsProgreso: [],
      headers: [
        { text: "Nivel", align: "left", sortable: false, value: "nivel" },
        { text: "Region", align: "left", sortable: false, value: "region" },
        { text: "Centro Acopio", sortable: false, value: "centroAcopio" },
        { text: "Centro Operacion", sortable: false, value: "centroOperacion" },
        { text: "ID Material", sortable: false, value: "material" },
        { text: "Fecha Movimiento", sortable: false, value: "fecha" },
        { text: "Accion", sortable: false, value: "accion" },
      ],
      fechaInicioValue: [],
      usuarioLoggedTipe: "",
      bloqueo: Boolean,
      itemsMateriales: [],
      centroAcopio: "",
      centroAcopioValue: null,
      centroAcopioSelect: [],
      centroOperacionValue: null,
      centroOperacionSelect: [],
      nivelValue: null,
      nivelSelect: [],
      tipoMaterialValue: null,
      tipoMaterialSelect: [],
      regionValue: null,
      regionesSelect: [],
      fechaValue: null,
      fechaSelect: [],
      resultadoValue: null,
      resultadoSelect: [],
      filter: false,
      tabSelected: "",
      filex: "",
      //----CARGA MASIVA---
      apiValidateDocument: "",
      apiSaveDocument: "",
      apiDownloadDocument: "",
      templateTitle: "",
    };
  },
  created() {
    this.loading = true;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;
    this.tabSelected = this.$store.getters.subTabSelectedStored;
    //se indican las apis a utilizar
    this.apiValidateDocument = "/cronograma/preProcess/CA-CO";
    this.apiSaveDocument = "/cronograma/cargaMasiva/CA-CO";
    this.apiDownloadDocument = "/cronograma/downloadPlantilla/";
    this.templateTitle = "Planilla_Agendar_Cronograma";
    this.loadDataComuna();
    this.loadData();
  },
  mounted() {},
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 5000);
    },
  },
  methods: {
    getColor() {
      return "orange";
    },
    openCronograma() {
      setTimeout(() => {
        this.$router.push({
          name: "FormCronogramaCO",
          params: { tipeView: "crear", titleView: "Nuevo Cronograma" },
        });
      }, 1000);
    },
    viewCronograma(id) {
      setTimeout(() => {
        this.$router.push({
          name: "FormCronogramaCO",
          params: {
            idCronograma: id,
            tipeView: "consulta",
            titleView: "Consulta Cronograma",
          },
        });
      }, 1000);
    },

    async loadCronogramaFilter() {
      let that = this;
      let subTab = this.$store.getters.subTabSelectedStored;
      let proceso = this.$store.getters.proSelectedStored;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        region:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        centroCaCo:
          this.centroAcopioValue && this.centroAcopioValue != null
            ? this.centroAcopioValue
            : null,
        centroCoCa: null,
        fechaMovimiento:
          this.fechaValue && this.fechaValue != null ? this.fechaValue : null,
        fechaMovimientoCoCa: null,
        tipoTraspaso: "CA-CO",
        idContrato: idContrato,
      };

      return await axios
        .post("/cronograma/agendar/filter", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },

    async loadData() {
      this.loading = true;
      this.itemsCronograma = await this.loadCronogramaFilter();
      this.miPaginacion.totalItems = this.itemsCronograma.length;
      this.loading = false;
      if (this.itemsCronograma.length > 0) {
        this.loadCentroOrigenSelect();
        this.loadCentroDestinoSelect();
        this.loadFechaSelect();
      }
    },
    loadRegionSelect() {
      let reg = [];
      this.itemsCronograma.forEach(function (c) {
        let index = reg.findIndex((x) => x.region == c.region.nombre);
        if (index === -1) {
          reg.push(c.region.nombre);
        }
      });
      this.regionSelect = reg;
    },
    loadCentroOrigenSelect() {
      let com = [];
      this.itemsCronograma.forEach(function (c) {
        let index = com.findIndex(
          (x) => x.centroOrigen == c.centroOrigen.codCentro
        );
        if (index === -1) {
          com.push(c.centroOrigen.codCentro);
        }
      });
      this.centroAcopioSelect = com;
    },
    loadCentroDestinoSelect() {
      let com = [];
      this.itemsCronograma.forEach(function (c) {
        let index = com.findIndex(
          (x) => x.centroDestino == c.centroDestino.codCentro
        );
        if (index === -1) {
          com.push(c.centroDestino.codCentro);
        }
      });
      this.centroOperacionSelect = com;
    },
    loadFechaSelect() {
      let est = [];
      this.itemsCronograma.forEach(function (c) {
        let index = est.findIndex(
          (x) => x.fecha_movimiento == c.fecha_movimiento
        );
        if (index === -1) {
          est.push(c.fecha_movimiento);
        }
      });
      this.fechaSelect = est;
    },
    clear() {
      this.regionValue = "";
      this.centroAcopioValue = "";
      this.centroOperacionValue = "";
      this.fechaValue = "";
      this.loadData();
    },
    //SOLO NUMEROS
    bloqueoEdicion(tip) {
      if (tip == "AGENCIA") {
        this.bloqueo = true;
      }
      if (tip == "PROVEEDOR") {
        this.bloqueo = false;
      }
      return this.bloqueo;
    },
    filterCronograma() {
      this.filter = true;
      this.loadData();
    },
    downloadComplete() {
      this.dialogLoading = true;
      let idContrato = this.$store.getters.contratoStored;
      let fileName = "Registro_Cronograma.xlsx";
      this.body = {
        region:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        centroCaCo:
          this.centroAcopioValue && this.centroAcopioValue != null
            ? this.centroAcopioValue
            : null,
        centroCoCa: null,
        fechaMovimiento:
          this.fechaValue && this.fechaValue != null ? this.fechaValue : null,
        fechaMovimientoCoCa: null,
        tipoTraspaso: "CA-CO",
        idContrato: idContrato,
      };
      axios
        .post("/cronograma/downloadExcel", this.body, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
  },
};
</script>
